<template>
	<div :class="{'header': true, 'fixed':isfixHeader}">
		<!-- <a v-if="$route.meta.indexLink" href="/" class="logo">
			<img src="../../assets/logo.png" alt="麒麟软件"/>
		</a> -->
		<a href="/" class="logo">
			<img src="../../assets/logo.png" alt="麒麟软件"/>
		</a>
		<div class="nav">
			<ul class="nav-list">
                <li><router-link to="/home">活动首页</router-link></li>
				<li><router-link to="/messageBoard">留言区</router-link></li>
				<!-- <li><a href="javascript:;" class="disabled">活动列表</a></li>
				<li><a href="javascript:;" class="disabled">论坛</a></li>
				<li><a href="javascript:;" class="disabled">支持</a></li> -->
			</ul>
		</div>
        <!--登录前-->
        <ul class="header-btns" v-if="!userId">
            <li><router-link to="/login">登录</router-link></li>
            <li class="register-btn"><a :href="registerUrl" target="_blank">注册</a></li>
        </ul>
        <!--登录后-->
        <div class="header-user" v-else>
            <el-dropdown>
                <span class="username">{{userInfo.mail}}</span>
                <el-dropdown-menu slot="dropdown">
                    <div class="dropdown-cnt">
                        <div class="user-avatar clearfix">
                            <img :src="userInfo.headPic!=''?userInfo.headPic:require('../../assets/default_avatar.png')"/>
                            <span>{{userInfo.mail}}</span>
                        </div>
                        <ul class="userinfo-list">
                            <li><router-link to="/userinfo/baseinfo">个人资料</router-link></li>
                            <li class="integral-user"><a href="javascript:;">我的积分</a>  <strong>{{userInfo.integralNum}}</strong></li>
                            <li><router-link to="/userinfo/mytask">我的任务</router-link></li>
                            <!-- <li><a href="javascript:;" class="disabled">我的消息</a></li>
                            <li><a href="javascript:;" class="disabled">我的活动</a></li> -->
							<li><router-link to="/userinfo/messageMy">我的留言</router-link></li>
                            <!-- <li><router-link to="/userinfo/account">账号设置</router-link></li> -->
                        </ul>
                        <span class="loginout" @click="toLoginout">退出</span>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
	</div>
</template>
<script>
import qs from 'qs'
import { post,ajaxParam } from '../../units/request.js'
export default {
    name: 'Header',
    data(){
        return {
            userId: '',
            userInfo: {},
            registerUrl: 'https://id.kylinos.cn/registered?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
            returnUrl: '',
			isfixHeader: false
        }
    },
    methods: {
        toLoginout(){
            this.$confirm('确定要退出登录？','温馨提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async()=>{
                localStorage.removeItem('user')
                localStorage.removeItem('userId')
                localStorage.removeItem('token')
                localStorage.removeItem('radioDialog')
                let isLoginStudent = localStorage.getItem('isLoginStudent')
                if(isLoginStudent==1) {
					this.$router.push('/loginstudent')
                } else {
					this.$router.push('/login')
                }
                setTimeout(()=>{
					localStorage.removeItem('isLoginStudent')
                },300)
            }).catch(()=>{

            })
        },
        //获取用户信息积分信息
        async getUserIntegral(){
            let url = 'v1/integral/getUserIntegral'
            let param = {
                userId: this.userId,
                token:localStorage.getItem('token'),
                activityId: this.activityId
            }
            ajaxParam(param)
            const res = await post(url, qs.stringify(param))
            //console.log(res)
            if(res.data.code==200) {
                this.userInfo = res.data.entity
            } else {
                this.$message.error(res.data.msg)
            }
        },
        async getRedirectUrl() {
            let param = {
                code: 'QILIN-ID-REDIRECT-LOGIN'
            }
            ajaxParam(param)
            const res = await post('/v1/sysConfig/getConfigByCode', qs.stringify(param))
            if(res.data.code==200) {
                this.returnUrl = res.data.entity.configValue
                this.registerUrl = this.registerUrl+ this.returnUrl
            }
        },
		handleHeaderFix(){
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			scrollTop > 0 ? this.isfixHeader = true : this.isfixHeader = false
		}
    },
	mounted(){
		window.addEventListener('scroll', this.handleHeaderFix, true)
	},
    created(){
        this.userId = localStorage.getItem('userId')
        this.activityId = localStorage.getItem('activityId')
        if(this.userId){
            this.getUserIntegral()
        }
        //this.getRedirectUrl()
    }
}
</script>
<style scoped>
    .header{
        width: 100%;
        min-width: 1024px;
        height: 89px;
		background:#fff;
        box-shadow: 0px 3px 12px 0px rgba(217, 217, 217, 0.47);
    }
	.fixed{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}
    .header>a{
        float: left;
    }
    .header>a img{
        height: 90px;
    }
    .nav{
        float: left;
    }
    .header-btns{
        float: right;
        margin-right: 50px;
        margin-top: 29px
    }
    .header-btns li{float: left;width: 60px; height: 34px; text-align: center;  line-height: 34px;}
    .register-btn{ background: #DE0515; color: #fff;}
    .register-btn a{color:#fff}
    .nav{float: left; margin-left: 80px}
    .nav-list li{float: left; margin-right:60px; line-height: 89px;}
    .nav-list li a{display:block; width:100%; height: 100%; font-size: 18px;}
    .nav-list li a.router-link-active{border-bottom: 3px solid #DE0515; font-size: 20px; font-weight: bold;}
    .header-user{float: right; margin-right: 40px}
    .username{display: block; line-height: 80px;}
    .dropdown-cnt{width:200px;}
    .user-avatar{padding:10px}
    .user-avatar img{float:left;width:40px; height:40px; border-radius: 50%;}
    .user-avatar span{display: block; float: left; width:130px; margin-left:10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 40px;}
    .userinfo-list{ border-top:1px solid #eee; border-bottom:1px solid #eee}
    .userinfo-list li{height:40px; padding:0 10px; line-height: 40px;}
    .userinfo-list li a{display: block; width:100%; height:100%}
    .userinfo-list li.integral-user a{display: inline-block; width:80px}
    .userinfo-list li.integral-user strong{color:#DE0515}
    .userinfo-list li.integral-user:hover strong{color:#fff}
    .loginout{display: block; height:30px; padding:0 10px; line-height: 30px;}
    .userinfo-list li:hover,.loginout:hover,.userinfo-list li a:hover{background:#de0515; color:#fff}
</style>
